"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _knockReceived = _interopRequireDefault(require("../../../actions/knock/knockReceived"));
var _user = require("../../../utils/user");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function knocked(_ref, payload) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  if ((0, _user.hasRealTimeCollaborationAccess)(getState)) {
    dispatch((0, _knockReceived["default"])(payload));
  }
}
var _default = exports["default"] = knocked;